(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lm-ui", [], factory);
	else if(typeof exports === 'object')
		exports["lm-ui"] = factory();
	else
		root["lm-ui"] = factory();
})(this, function() {
return 